import React from "react"

import { Hit } from "@algolia/client-search"

import { AlgoliaSearch } from "../../../modules/algolia"

export type SearchProps = React.InputHTMLAttributes<HTMLInputElement> & {
  onClose?: (event: React.MouseEvent<HTMLElement>) => void
}

type CustomHighlightProps = {
  attribute: string
  hit: Hit<AlgoliaSearch>
}

type HighlightResult = {
  value: string
  matchLevel: string
  matchedWords: string[]
}

export const CustomHighlight = ({ attribute, hit }: CustomHighlightProps) => {
  const highlightedValue =
    (hit._highlightResult?.[attribute] as HighlightResult)?.value ||
    (typeof hit[attribute as keyof AlgoliaSearch] === "string"
      ? (hit[attribute as keyof AlgoliaSearch] as string)
      : "")

  if (!highlightedValue) {
    return null
  }

  // Split the text by the highlight tags
  const parts = highlightedValue.split(/<em>|<\/em>/)

  return parts.map((part: string, index: number) => {
    // Even indices are non-highlighted parts
    if (index % 2 === 0) {
      return <span key={index}>{part}</span>
    }
    // Odd indices are highlighted parts
    return <b key={index}>{part}</b>
  })
}
